import axios from 'axios';
import {useQuery} from '@tanstack/react-query';

import {Keys} from 'client/api/_keys';
import {Routes} from 'client/api/_routes';

const version = async () => axios.get(Routes.VERSION);

export const useVersion = () =>
  useQuery({
    queryKey: [Keys.VERSION_QRY],
    queryFn: version,
    cacheTime: 0,
  });
